import React, {useEffect} from 'react'
import {useLocation} from "react-router";


const PaymentPage = () => {
  const location = useLocation();
  let url = location.state as string;

  useEffect(()=>{
    goToPaymentGateway()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

const goToPaymentGateway = () =>{
  window.location.href=url
};
  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      flex: 1,
      height: "-webkit-fill-available",
      backgroundColor: "#fff"
    }}>
    </div>
  )

};

export default PaymentPage;
